// extracted by mini-css-extract-plugin
export default {"price":"i9-z","priceRow":"j9-z","onSale":"k9-z","msrpLabelPrice":"l9-z","msrpLabel":"m9-z","originalPrice":"n9-z","percentOff":"o9-z"};